import { render, staticRenderFns } from "./OrderCreate.vue?vue&type=template&id=36dd60da&scoped=true"
import script from "./OrderCreate.vue?vue&type=script&lang=js"
export * from "./OrderCreate.vue?vue&type=script&lang=js"
import style0 from "./OrderCreate.vue?vue&type=style&index=0&id=36dd60da&prod&scoped=true&lang=css"
import style1 from "./OrderCreate.vue?vue&type=style&index=1&id=36dd60da&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36dd60da",
  null
  
)

export default component.exports